<template>
    <div>
        <NavBar />
        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Callback Number
                    </h1>
                </div>
            </header>
        </div>

        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <router-link to="/callers/create" class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-3 px-4 shadow rounded">Create</router-link>
                </div>
            </div>

            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead>
                                            <tr>
                                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                                    List Name
                                                </th>
                                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                                    Number of contacts
                                                </th>
                                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                                    Status
                                                </th>
                                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="bg-white divide-y divide-gray-200">
                                            <tr v-for="caller in callers" :key="caller.id">
                                                <td class="px-6 py-4 whitespace-no-wrap">
                                                    <div class="flex items-center">
                                                        <div class="text-sm leading-5 font-medium text-gray-900">
                                                            {{ caller.name }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-no-wrap">
                                                    <div class="text-sm leading-5 text-gray-900">{{ caller.phone_number}} </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-no-wrap">
                                                    <template v-if="caller.verified">
                                                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-200 text-green-800">
                                                            Verified
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-200 text-red-800">
                                                            Not Verified
                                                        </span>
                                                    </template>
                                                </td>
                                                <td class="px-6 py-4 whitespace-no-wrap">
                                                    <template v-if="!caller.verified">
                                                        <button @click="verify(caller)" class="text-sm leading-5">
                                                            Verify
                                                        </button>
                                                    </template>

                                                    <!-- <router-link :to="{ name: 'contact_lists_edit', params: { id: list.id }}" class="text-green-600 hover:text-green-900">Edit</router-link> -->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

                        <div v-if="isModalOpen" class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div @click="isModalOpen = false" class="fixed inset-0 transition-opacity">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

                    <div class="inline-block align-bottom bg-white rounded text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <form @submit.prevent="sendVerificationRequest">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                        Verify phone number
                                    </h3>
                                    <div class="mt-8">
                                        Need designs
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <span class="flex w-full rounded shadow-sm sm:ml-3 sm:w-auto">
                                <button
                                    class="inline-flex justify-center w-full rounded border border-transparent px-4 py-2 bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-700 sm:text-sm sm:leading-5"
                                >
                                    Request Verification
                                </button>
                            </span>
                            <span class="mt-3 flex w-full rounded shadow-sm sm:mt-0 sm:w-auto">
                                <button
                                    @click="isModalOpen = false"
                                    type="button"
                                    class="inline-flex justify-center w-full rounded border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                >
                                    Cancel
                                </button>
                            </span>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "../components/NavBar";

export default {
    name: "Caller",
    components: {
        NavBar,
    },
    data() {
        return {
            isModalOpen: false,

        }
    },
    methods: {
        verify(caller) {
            this.isModalOpen = true;
            console.log(caller)
        },
        sendVerificationRequest(e) {
            alert("Done");
            e.preventDefault();
        }
    },
    beforeMount() {
        this.$store.dispatch("loadCallers");
    },
    computed: {
        ...mapGetters([
            "callers"
        ])
    }
}
</script>